module.exports = __webpack_public_path__ + "fonts/VetoSans-Medium.240f0e9c.woff";